import React, { Component } from 'react';
import { otpMobileVerify, otpMobileResend } from '../../../../lib/otpmobilesign';
import CustomCarousel from "../../../carousel/theme11/CustomCarousel";

class VerifyOTP extends Component {
  constructor(props) {
    super(props);
    this.inputRefs = Array(6)
      .fill()
      .map(() => React.createRef());
    this.state = {
      otpValue: Array(6).fill(''),
      otpErr: '',
      onClickLoginLoader: false,
      resendLoader: false,
    };
  }

  async handleResendOtp() {
    this.setState({ resendLoader: true });
    try {
      const site_id = this.props?.siteData?.data?.site_id;
      const mobile = this.props?.verifyOtpMobile?.mobile;
      const res = await otpMobileResend({ mobile_number: mobile, site_id });
      if (res.status) {
        this.setState({ otpErr: '', resendLoader: false });
      } else {
        this.setState({ otpErr: res.message || 'Failed to resend OTP.', resendLoader: false });
      }
    } catch (err) {
      this.setState({ otpErr: 'Network error. Please try again.', resendLoader: false });
    }
  }

  async handleVerifyOtp() {
    const otpValue = this.state.otpValue;
    if (otpValue.some((digit) => !digit)) {
      this.setState({ otpErr: 'Please enter all 6 digits.' });
      return;
    }
    this.setState({ onClickLoginLoader: true });
    try {
      const site_id = this.props?.siteData?.data?.site_id;
      const mobile = this.props?.verifyOtpMobile?.mobile;
      const res = await otpMobileVerify({
        mobile_number: mobile,
        otp: otpValue.join(''),
        site_id,
      });

      if (res.status) {
        this.setState({ otpErr: '', onClickLoginLoader: false });
        // Successful verification → refresh
        window.location.reload();
      } else {
        this.setState({
          otpErr: res.message || 'Invalid OTP.',
          onClickLoginLoader: false,
        });
      }
    } catch (err) {
      this.setState({ otpErr: 'Network error. Please try again.', onClickLoginLoader: false });
    }
  }

  onChangeOTP = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;
    const updatedOtp = [...this.state.otpValue];
    updatedOtp[index] = value;
    this.setState({ otpValue: updatedOtp, otpErr: '' });

    // Move to next input if digit entered
    if (value && index < this.inputRefs.length - 1) {
      this.inputRefs[index + 1].current.focus();
    }
  };

  onPasteOTP = (index, e) => {
    e.preventDefault();
    const clipboardData = e.clipboardData.getData('text');
    const pastedDigits = clipboardData.match(/\d/g) || [];
    if (pastedDigits.length === 0) return;

    const updatedOtp = [...this.state.otpValue];
    for (let i = 0; i < 6 - index && i < pastedDigits.length; i++) {
      updatedOtp[index + i] = pastedDigits[i];
    }
    this.setState({ otpValue: updatedOtp, otpErr: '' });

    // Move focus to next unfilled box
    const nextIndex = index + pastedDigits.length;
    if (nextIndex < this.inputRefs.length) {
      this.inputRefs[nextIndex].current.focus();
    }
  };

  onKeyDownOTP = (index, e) => {
    if (e.key === 'Backspace') {
      if (this.state.otpValue[index]) {
        // Clear current box
        const updatedOtp = [...this.state.otpValue];
        updatedOtp[index] = '';
        this.setState({ otpValue: updatedOtp });
      } else if (index > 0) {
        // Move back if empty
        const updatedOtp = [...this.state.otpValue];
        updatedOtp[index - 1] = '';
        this.setState({ otpValue: updatedOtp });
        this.inputRefs[index - 1].current.focus();
      }
    }
  };

  render() {
    const { styles, verifyOtpMobile, isMobile } = this.props;
    const otpValue = this.state.otpValue;
    const mobileData = verifyOtpMobile || { isd: '', mobile: '' };

    const imageLoader = ({ src }) => `/shared/api/media/${src}`;
    const banners = this.props?.siteData?.data?.signin?.banners;
    const PromotionBannerCss = this.props.PromotionBannerCss;

    const customResponsive = {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: { breakpoint: { max: 1024, min: 464 }, items: 2, slidesToSlide: 2 },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
    };

    return (
      <div className={styles.main_content}>
        {/* Left side - Promotional Banner */}
        <div className={styles.login_banner}>
          <CustomCarousel
            banners={banners}
            imageLoader={imageLoader}
            cssstyles={PromotionBannerCss}
            arrows={false}
            dots={true}
            autoplay={false}
            imageKey="upload_image"
            prevArrow={"/images/back-arrow.png"}
            nextArrow={"/images/back-arrow.png"}
            responsive={customResponsive}
          />
          {isMobile ? (
            <div className={styles.banner_left_arrrow}>
              <img src="images/te_Left_Arrow.svg" alt="arrow" />
            </div>
          ) : null}
        </div>

        {/* Right side - OTP form */}
        <div className={styles.login_section}>
          <div className={styles.login_form}>
            <div className={styles.form_header}>
              <h3>Verification</h3>
              <div className={styles.form_otp_header}>
                <span className={styles.otp_label}>Please enter OTP code sent on </span>
                <span className={styles.otp_mobile_number}>
                  your mobile number {mobileData.isd} {mobileData.mobile}
                </span>
              </div>
            </div>

            <div className={styles.form_group}>
              <label htmlFor="otp">OTP Code</label>
              <div className={styles.otp_verification_otp_wrapper}>
                {[...Array(6)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    className={styles.otp_verification_otp_input}
                    value={otpValue[index] || ''}
                    onChange={(e) => this.onChangeOTP(e.target.value, index)}
                    onPaste={(e) => this.onPasteOTP(index, e)}
                    onKeyDown={(e) => this.onKeyDownOTP(index, e)}
                    ref={this.inputRefs[index]}
                    aria-label={`OTP digit ${index + 1}`}
                  />
                ))}
              </div>
              {this.state.otpErr && <div className={styles.error_text}>{this.state.otpErr}</div>}
            </div>

            <div className={styles.resend_otp}>
              <span className={styles.resend_label}>If you didn't receive a code</span>
              <button
                className={styles.resend_button}
                onClick={() => this.handleResendOtp()}
                disabled={this.state.resendLoader}
              >
                {this.state.resendLoader ? "Resending..." : "Resend OTP"}
              </button>
            </div>

            <button
              className={`${styles.login_btn} ${this.state.onClickLoginLoader ? "loading" : ''}`}
              onClick={() => this.handleVerifyOtp()}
              disabled={this.state.onClickLoginLoader}
            >
              {this.state.onClickLoginLoader ? "Verifying..." : "Verify"}
              <img src="images/te_Arrow_right.svg" alt="arrow" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default VerifyOTP;
